const language = {
  lang: 'zh-TW',
  gameID: 54,
  websiteId: 54,
  'zh-TW': {
    newsID: '234,235,236',
    guidesID: '234',
    eventsID: '235',
    noticesID: '236',
    language: '繁体中文',
    sLang: 'zh-TW',
  },
  change(lang) {
    this.lang = lang;
  },
  get(key) {
    var lang = this.lang;
    return this[lang][key];
  },
  getLang() {
    return this['lang'];
  },
};
export default language;
